import React from 'react'
import "../assets/pages-css/home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from '../components/globals/home/footer';
import Copyright from '../components/globals/home/copyright';
import Header from '../components/globals/home/header';

const Support = () => {

  return (
    <>
      <Header />
      <div className='container mt-4 mb-4'>
        <h1>Welcome to SharkSkillz</h1>
        <p>We at SharkSkillz understand the importance of financial literacy and its impact on personal development. Our education app is designed to empower you with the necessary knowledge and skills to enhance your understanding of finance. With a range of features including quests (multiple-choice questions), oceans (lessons), games, and shark character customisation, SharkSkillz offers an engaging and interactive platform to develop your financial literacy.</p>

        <h2>Features</h2>
        <p>By completing quests and accessing different oceans, you can gain insights into various financial concepts, such as:</p>
        <ul>
          <li>Budgeting</li>
          <li>Investing</li>
          <li>Saving</li>
          <li>And more</li>
        </ul>
        <p>Our carefully curated lessons provide practical information and real-life scenarios to help you make informed financial decisions. Through gameplay and customisation options, you can personalise your SharkSkillz experience and dive into the world of finance with a sense of fun and adventure.</p>

        <h2>Your Experience Matters</h2>
        <p>We strive to provide a seamless and user-friendly experience on SharkSkillz. However, if you encounter any issues or have suggestions for improvement, please do not hesitate to reach out to us. Your feedback is valuable to us, and we appreciate your support in making SharkSkillz an even better app. You can contact us at <a href="mailto:skillz@sharkskillz.com" style={{ color: 'black' }}>skillz@sharkskillz.com</a>, and we will be happy to assist you and address any concerns you may have.</p>

        <h2>Thank You</h2>
        <p>Thank you for choosing SharkSkillz as your go-to app for developing financial literacy skills. We are committed to continuously enhancing our app to meet your educational needs and provide you with a reliable and enjoyable learning experience. Happy learning!</p>
      </div>
      <Footer />
      <Copyright />
    </>
  )
}

export default Support;